import { SwapperComponent } from '../../components/kt/components'

export class SwapperStore {
   static readonly store: Map<string, SwapperComponent> = new Map()

   public static set(instanceId: string, drawerComponentObj: SwapperComponent): void {
      if (SwapperStore.has(instanceId)) {
         return
      }

      SwapperStore.store.set(instanceId, drawerComponentObj)
   }

   public static get(instanceId: string): SwapperComponent | undefined {
      if (!SwapperStore.has(instanceId)) {
         return
      }
      return SwapperStore.store.get(instanceId)
   }

   public static remove(instanceId: string): void {
      if (!SwapperStore.has(instanceId)) {
         return
      }

      SwapperStore.store.delete(instanceId)
   }

   public static has(instanceId: string): boolean {
      return SwapperStore.store.has(instanceId)
   }

   public static getAllInstances() {
      return SwapperStore.store
   }
}
